<template>
  <div>
    <b-button @click="open" variant="primary">Abrir</b-button>
  </div>
</template>

<script>
  import Parse from 'parse'
  import Vue from 'vue'

  Vue.use(Parse)
  Parse.initialize("bBzZ7wYYGIpQkPPB");
  Parse.serverURL = 'https://aircab.herokuapp.com/parse'
  // Parse.initialize("BewIZ9dlh4gNBStm")
  // Parse.serverURL = 'https://aircabdev.herokuapp.com/parse'
  export default {
    data() {
      return {
        email: null,
        password: null,
        error: false,
        errorMsg: ''
      }
    },
    async created () {
      var currentUser = Parse.User.current()
      console.log('created currentUser', currentUser)
    },
    methods: {
      open () {
        window.open('/login','winname',"directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=400,height=350");
      },
    }
  }
</script>